module.exports = __webpack_public_path__ + "media/images/badges/rumble/milestone-1500-Inactive-Rumble-276abb42a28ab348b3b29c04597eca1e.png";